module.exports = __webpack_public_path__ + "img/mccs_mobile.d5ddf123.png";